module.exports = __webpack_public_path__ + "static/img/sfzyq.69d1b57d.jpg";